import { SimpleGrid, Box, Text, HStack, Icon } from '@chakra-ui/react'
import { HiOutlineEye, HiOutlineScale, HiOutlineSwitchHorizontal, HiOutlineExclamationCircle } from 'react-icons/hi'

const iconMap = {
  '观察标的': HiOutlineEye,
  '未平仓': HiOutlineScale,
  '今日交易': HiOutlineSwitchHorizontal,
  '风险提示': HiOutlineExclamationCircle,
}

const colorMap = {
  '观察标的': 'brand.600',
  '未平仓': 'green.600',
  '今日交易': 'blue.600',
  '风险提示': 'orange.600',
}

const OverviewStrip = ({ stats }) => (
  <SimpleGrid columns={{ base: 2, md: 4 }} gap={4} mb={8}>
    {stats.map((item) => (
      <Box
        key={item.label}
        bg="bg.surface"
        borderRadius="lg"
        p={4}
        border="1px solid"
        borderColor="border.subtle"
        shadow="sm"
        transition="all 0.2s"
        _hover={{ borderColor: 'border.default' }}
      >
        <HStack justify="space-between" mb={2}>
          <Text color="text.muted" fontSize="xs" fontWeight="600">
            {item.label}
          </Text>
          <Icon
            as={iconMap[item.label] || HiOutlineEye}
            color={colorMap[item.label] || 'gray.500'}
            boxSize={4}
          />
        </HStack>
        <Text fontSize="2xl" fontWeight="600" color="text.main" fontFamily="mono">
          {item.value}
        </Text>
      </Box>
    ))}
  </SimpleGrid>
)

export default OverviewStrip
